(() => {
  const formatMoney = (cents, moneyFormat, currency) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(cents / 100);
  };

  const init = (section) => {
    if (!section || section.dataset.dlbReady === 'true') return;
    section.dataset.dlbReady = 'true';
    document.body.classList.add('dlb-supplier-product-template');

    if (section.dataset.disableThemeStickyHeader === 'true') {
      const header = document.querySelector('#header-component[sticky]');
      if (header) {
        header.dataset.dlbOriginalSticky = header.getAttribute('sticky') || '';
        header.removeAttribute('sticky');
        header.removeAttribute('data-sticky-state');
      }
    }

    const thumbs = Array.from(section.querySelectorAll('[data-dlb-thumb]'));
    const mainImage = section.querySelector('[data-dlb-main-image]');
    const counter = section.querySelector('[data-dlb-counter]');
    const lightbox = section.querySelector('[data-dlb-lightbox]');
    const lightboxImage = section.querySelector('[data-dlb-lightbox-image]');
    let currentIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    let touchStartX = 0;

    const imageData = (thumb) => ({
      src: thumb.dataset.src || '',
      srcset: thumb.dataset.srcset || '',
      alt: thumb.dataset.alt || '',
      zoom: thumb.dataset.zoom || thumb.dataset.src || ''
    });

    const updateImage = (index) => {
      if (!mainImage || !thumbs.length) return;
      currentIndex = (index + thumbs.length) % thumbs.length;
      const selected = thumbs[currentIndex];
      const data = imageData(selected);
      mainImage.classList.add('is-changing');
      window.setTimeout(() => {
        mainImage.src = data.src;
        if (data.srcset) mainImage.srcset = data.srcset;
        else mainImage.removeAttribute('srcset');
        mainImage.alt = data.alt;
        mainImage.dataset.zoom = data.zoom;
        mainImage.classList.remove('is-changing');
      }, 90);
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === currentIndex);
        thumb.setAttribute('aria-current', thumbIndex === currentIndex ? 'true' : 'false');
      });
      selected.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      if (counter) counter.textContent = `${currentIndex + 1} / ${thumbs.length}`;
      if (lightbox && !lightbox.hidden && lightboxImage) {
        lightboxImage.src = data.zoom;
        lightboxImage.alt = data.alt;
      }
    };

    const showLightbox = () => {
      if (!lightbox || !lightboxImage || !mainImage) return;
      lightboxImage.src = mainImage.dataset.zoom || mainImage.src;
      lightboxImage.alt = mainImage.alt;
      lightbox.hidden = false;
      document.body.classList.add('dlb-lightbox-open');
      section.querySelector('[data-dlb-lightbox-close]')?.focus();
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.classList.remove('dlb-lightbox-open');
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => updateImage(index)));
    section.querySelectorAll('[data-dlb-gallery-prev]').forEach((button) => button.addEventListener('click', () => updateImage(currentIndex - 1)));
    section.querySelectorAll('[data-dlb-gallery-next]').forEach((button) => button.addEventListener('click', () => updateImage(currentIndex + 1)));
    section.querySelector('[data-dlb-open-lightbox]')?.addEventListener('click', showLightbox);
    section.querySelector('[data-dlb-lightbox-close]')?.addEventListener('click', closeLightbox);
    lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });

    const stage = section.querySelector('.dlb-supplier-gallery__stage');
    stage?.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.screenX || 0; }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      const distance = (event.changedTouches[0]?.screenX || 0) - touchStartX;
      if (Math.abs(distance) < 45) return;
      updateImage(distance < 0 ? currentIndex + 1 : currentIndex - 1);
    }, { passive: true });
    stage?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); updateImage(currentIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); updateImage(currentIndex + 1); }
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); showLightbox(); }
    });

    document.addEventListener('keydown', (event) => {
      if (!lightbox || lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') updateImage(currentIndex - 1);
      if (event.key === 'ArrowRight') updateImage(currentIndex + 1);
    });

    const tabButtons = Array.from(section.querySelectorAll('[data-dlb-tab]'));
    const tabPanels = Array.from(section.querySelectorAll('[data-dlb-panel]'));
    const activateTab = (button, moveFocus = false) => {
      if (!button) return;
      const target = button.dataset.dlbTab;
      tabButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });
      tabPanels.forEach((panel) => {
        const active = panel.dataset.dlbPanel === target;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      if (moveFocus) button.focus();
    };

    tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => activateTab(button));
      button.addEventListener('keydown', (event) => {
        let nextIndex = -1;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabButtons.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabButtons.length) % tabButtons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabButtons.length - 1;
        if (nextIndex < 0) return;
        event.preventDefault();
        activateTab(tabButtons[nextIndex], true);
      });
    });

    section.querySelector('[data-dlb-open-specs]')?.addEventListener('click', () => {
      const button = tabButtons.find((item) => item.dataset.dlbTab === 'specifications');
      activateTab(button);
      section.querySelector('.dlb-supplier-tabs')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    const stickyBuy = section.querySelector('[data-dlb-sticky-buy]');
    const hero = section.querySelector('[data-dlb-product-hero]');
    if (stickyBuy && hero && section.dataset.enableStickyBuy === 'true' && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        const visible = !entry.isIntersecting && window.scrollY > hero.offsetTop;
        stickyBuy.classList.toggle('is-visible', visible);
        stickyBuy.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }, { threshold: 0.08 });
      observer.observe(hero);
    }

    const variantsNode = section.querySelector('[data-dlb-variants]');
    const optionInputs = Array.from(section.querySelectorAll('[data-dlb-option]'));
    const idInput = section.querySelector('[data-dlb-variant-id]');
    if (variantsNode && optionInputs.length && idInput) {
      const variants = JSON.parse(variantsNode.textContent || '[]');
      const moneyFormat = section.dataset.moneyFormat || '${{amount}}';
      const currency = section.dataset.currency || 'GBP';
      optionInputs.forEach((select) => select.addEventListener('change', () => {
        const selected = optionInputs.map((item) => item.value);
        const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
        if (!variant) return;
        idInput.value = variant.id;
        const formattedPrice = formatMoney(variant.price, moneyFormat, currency);
        section.querySelectorAll('[data-dlb-price], [data-dlb-sticky-price]').forEach((price) => { price.textContent = formattedPrice; });
        const compare = section.querySelector('[data-dlb-compare-price]');
        if (compare) {
          compare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price, moneyFormat, currency) : '';
          compare.hidden = !(variant.compare_at_price > variant.price);
        }
        const sku = section.querySelector('[data-dlb-sku]');
        if (sku) sku.textContent = variant.sku || variant.id;
        section.querySelectorAll('[data-dlb-add], [data-dlb-sticky-add]').forEach((add) => {
          add.disabled = !variant.available;
          add.textContent = variant.available ? add.dataset.availableText : add.dataset.soldText;
        });
        const availability = section.querySelector('[data-dlb-availability]');
        if (availability) {
          availability.innerHTML = variant.available
            ? '<span class="dlb-supplier-buybox__dot is-in"></span><strong>In stock</strong><span>— ready to order</span>'
            : '<span class="dlb-supplier-buybox__dot is-out"></span><strong>Out of stock</strong>';
        }
        const stickyStock = section.querySelector('[data-dlb-sticky-stock]');
        if (stickyStock) stickyStock.textContent = variant.available ? 'In stock' : 'Out of stock';
        if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
      }));
    }
  };

  const initAll = (root = document) => root.querySelectorAll('[data-dlb-supplier-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
